import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04f4abb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popUp" }
const _hoisted_2 = { class: "wrapper-top" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-bottom" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      class: "wrapper"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _renderSlot(_ctx.$slots, "text", {}, undefined, true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('on-close')), ["prevent"])),
          class: "btn btn-cancel"
        }, [
          _renderSlot(_ctx.$slots, "cancel", {}, () => [
            _hoisted_5
          ], true)
        ])
      ])
    ])
  ]))
}